<!-- Floating SVG Background Icons -->
<div class="floating-icons-bg">
  <svg class="float-icon icon-1" viewBox="0 0 24 24" fill="none">
    <path d="M9 18V5l12-2v13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="6" cy="18" r="3" stroke="currentColor" stroke-width="1.5"/>
    <circle cx="18" cy="16" r="3" stroke="currentColor" stroke-width="1.5"/>
  </svg>
  <svg class="float-icon icon-2" viewBox="0 0 24 24" fill="none">
    <path d="M12 3v18M8 7v10M4 10v4M16 7v10M20 10v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  </svg>
  <svg class="float-icon icon-3" viewBox="0 0 24 24" fill="none">
    <path d="M12 14a4 4 0 004-4V6a4 4 0 00-8 0v4a4 4 0 004 4z" stroke="currentColor" stroke-width="1.5"/>
    <path d="M19 10v1a7 7 0 01-14 0v-1M12 18v4M8 22h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
  <svg class="float-icon icon-4" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
  </svg>
  <svg class="float-icon icon-5" viewBox="0 0 24 24" fill="none">
    <path d="M3 18v-6a9 9 0 0118 0v6" stroke="currentColor" stroke-width="1.5"/>
    <path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3v5zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3v5z" stroke="currentColor" stroke-width="1.5"/>
  </svg>
  <svg class="float-icon icon-6" viewBox="0 0 24 24" fill="none">
    <path d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2z" stroke="currentColor" stroke-width="1.5"/>
  </svg>
</div>

@if (isPageLoading) {
  <div class="home-loading">
    <div class="spinner"></div>
  </div>
}

<main class="one-page" [class.dimmed]="isPageLoading">
  <!-- HERO -->
  <section id="hero" class="hero-section">
    <div class="hero-content">
      <img src="assets/images/logo_eclats_grisrotate.png" alt="Applisound Logo" class="hero-logo animated-logo" loading="eager">
      <h1 class="hero-title">{{ 'HOME.TITLE' | translate }}</h1>
      <p class="hero-tagline">{{ 'HOME.TAGLINE' | translate }}</p>
      <div class="hero-buttons">
        <button class="btn-primary pulse" (click)="scrollToSection('samples')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M5 3l14 9-14 9V3z"/></svg>
          {{ 'HOME.CTA_LISTEN' | translate }}
        </button>
        <button class="btn-secondary" (click)="openQuote()">{{ 'HOME.CTA_QUOTE' | translate }}</button>
      </div>
    </div>
    <div class="scroll-hint" (click)="scrollToSection('samples')">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12l7 7 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </div>
  </section>

  <!-- SAMPLES -->
  <section id="samples" class="samples-section">
    <h2 class="section-title">{{ 'HOME.INSTANT_LISTEN_TITLE' | translate }}</h2>
    <div class="players-carousel">
      <button class="nav-btn prev" (click)="scrollCarousel(-1)" aria-label="Previous">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
      <div class="players-wrapper" #playersWrapper>
        <app-player-soundtracks [config]="PLAYER_CONFIGS['soundtracks']" size="compact"></app-player-soundtracks>
        <app-player-soundtracks [config]="PLAYER_CONFIGS['jingles']" size="compact"></app-player-soundtracks>
        <app-player-soundtracks [config]="PLAYER_CONFIGS['voiceovers']" size="compact"></app-player-soundtracks>
        <app-player-soundtracks [config]="PLAYER_CONFIGS['sound_design']" size="compact"></app-player-soundtracks>
        <app-player-soundtracks [config]="PLAYER_CONFIGS['hymns']" size="compact"></app-player-soundtracks>
      </div>
      <button class="nav-btn next" (click)="scrollCarousel(1)" aria-label="Next">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    </div>
  </section>

  <!-- SOUNDSVIDEO CTA -->
  <section id="soundsvideo-cta" class="soundsvideo-cta-section">
    <div class="cta-content">
      <div class="cta-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
          <rect x="2" y="4" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
          <path d="M10 9l4 2.5-4 2.5V9z" fill="currentColor"/>
          <path d="M6 21h12M9 18v3M15 18v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </div>
      <h2>{{ 'HOME.SOUNDSVIDEO_CTA_TITLE' | translate }}</h2>
      <p>{{ 'HOME.SOUNDSVIDEO_CTA_DESC' | translate }}</p>
      <a routerLink="/soundsvideo" class="btn-soundsvideo">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" fill="currentColor"/>
          <path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="1.5"/>
        </svg>
        {{ 'HOME.SOUNDSVIDEO_CTA_BTN' | translate }}
      </a>
    </div>
  </section>

  <!-- SERVICES -->
  <section id="services" class="services-section">
    <h2 class="section-title">{{ 'HOME.WHAT_WE_DO' | translate }}</h2>
    <div class="services-grid">
      @for (s of services; track s) {
        <article class="service-card">
          <div class="service-icon" [innerHTML]="s.icon"></div>
          <h3>{{ s.titleKey | translate }}</h3>
          <p>{{ s.descKey | translate }}</p>
        </article>
      }
    </div>
  </section>

  <!-- PROCESS -->
  <section id="process" class="process-section">
    <h2 class="section-title">{{ 'NAV.HOW_IT_WORKS' | translate }}</h2>
    <div class="process-steps">
      @for (step of processSteps; track step; let i = $index) {
        <div class="step">
          <div class="step-number">{{ i + 1 }}</div>
          <h3>{{ step.titleKey | translate }}</h3>
          <p>{{ step.descKey | translate }}</p>
        </div>
      }
    </div>
  </section>

  <!-- VOICEOVER -->
  <section id="voiceover" class="voiceover-section">
    <h2 class="section-title">{{ 'NAV.VOICEOVER' | translate }}</h2>
    <p class="section-subtitle">{{ 'VOICEOVER.STUDIO_DESC' | translate }}</p>
    <div class="vo-grid">
      @for (vo of voiceoverServices; track vo) {
        <div class="vo-card">
          <div class="vo-icon" [innerHTML]="vo.icon"></div>
          <h3>{{ vo.titleKey | translate }}</h3>
          <p>{{ vo.descKey | translate }}</p>
        </div>
      }
    </div>
    <div class="lang-flags">
      <span>🇫🇷</span>
    </div>
  </section>

  <!-- CLIENTS -->
  <section id="clients" class="clients-section">
    <h2 class="section-title">{{ 'HOME.AT_YOUR_SERVICE' | translate }}</h2>
    <div class="clients-grid">
      @for (c of clients; track c) {
        <div class="client-card">
          <div class="client-img"><img [src]="c.img" [alt]="c.titleKey | translate" loading="lazy"><span class="tag">{{ c.tag }}</span></div>
          <h3>{{ c.titleKey | translate }}</h3>
          <p>{{ c.descKey | translate }}</p>
        </div>
      }
    </div>
  </section>

  <!-- PRICING -->
  <section id="pricing" class="pricing-section">
    <h2 class="section-title">{{ 'PRICING.MAIN_TITLE' | translate }}</h2>
    <div class="currency-btns">
      @for (c of currencies; track c) {
        <button [class.active]="currentCurrency === c.symbol" (click)="setCurrency(c.code)">{{ c.label }}</button>
      }
    </div>
    <div class="pricing-carousel">
      <button class="nav-btn prev" (click)="scrollPricing(-1)" aria-label="Previous"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
      <div class="pricing-cards" #pricingWrapper>
        @for (card of pricingCards; track card) {
          <div class="pricing-card">
            <h3>{{ card.title | translate }}</h3>
            <ul>
              @for (svc of card.services; track svc) {
                <li><span class="name">{{ svc.name | translate }}</span><span class="price">{{ formatPrice(svc.price) }}</span></li>
              }
            </ul>
          </div>
        }
      </div>
      <button class="nav-btn next" (click)="scrollPricing(1)" aria-label="Next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
    </div>
  </section>

  <!-- TESTIMONIALS -->
  <section id="testimonials" class="testimonials-section">
    <h2 class="section-title">{{ 'HOME.TESTIMONIALS' | translate }}</h2>
    <p class="section-subtitle">{{ 'HOME.TESTIMONIALS_SUBTITLE' | translate }}</p>
    <div class="testimonials-grid">
      @for (t of testimonials; track t) {
        <div class="testimonial-card">
          <img [src]="t.logo" [alt]="t.name" class="t-logo">
          <h3>{{ t.name }}</h3>
          <p>{{ t.textKey | translate }}</p>
          <div class="mini-player" (click)="playTestimonial(t.id)">
            <button class="play-btn" [class.playing]="currentTestimonial === t.id && isPlayingTestimonial">
              @if (!(currentTestimonial === t.id && isPlayingTestimonial)) {
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M5 3l14 9-14 9V3z"/></svg>
              }
              @if (currentTestimonial === t.id && isPlayingTestimonial) {
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
              }
            </button>
            <span class="track-name">{{ t.track }}</span>
            <div class="progress-bar"><div class="progress" [style.width.%]="testimonialProgress[t.id] || 0"></div></div>
          </div>
        </div>
      }
    </div>
  </section>

  <!-- CTA FINAL -->
  <section id="cta" class="cta-section">
    <h2>{{ 'HOME.BE_MORE_THAN_WINNER' | translate }}</h2>
    <p>{{ 'HOME.RIGHTS_DESCRIPTION' | translate }}</p>
    <button class="btn-primary large" (click)="openQuote()">{{ 'HOME.CTA_QUOTE' | translate }}</button>
  </section>
</main>
